import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    BrowserRouter as Router,
    Switch,
    useHistory,
    useLocation
} from 'react-router-dom';
import Main from '@modules/main/Main';
import Login from '@modules/login/Login';
import ForgetPassword from '@modules/forgot-password/ForgotPassword';
import RecoverPassword from '@modules/recover-password/RecoverPassword';
import PrivacyPolicy from '@modules/privacy-policy/PrivacyPolicy';
import jwt_decode from 'jwt-decode';
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import {URI_INTERNAL} from './utils/pathLocations';
import {
    REFRESH_TOKEN_KEY,
    refreshingPromise,
    TOKEN_KEY
} from '../src/utils/define';
import 'react-datepicker/dist/react-datepicker.css';
import {logoutUser, refreshTokenFunc} from '@store/reducers/auth';
import './App.scss';
import {checkExpToken} from '@app/utils/helper';
import {getMenuAction} from '@app/store/reducers/menuItem';
import {apiRoleMappingPagingAction} from '@app/store/reducers/apiRoleMapping';
import {persistor} from '@app/store/store';
import Callback from '@app/modules/login/Callback';
import {userManager} from '@app/utils/oidc';
import LoginSSO from '@app/modules/login/LoginSSO';

const App = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    //const isLoggedIn = useSelector(s => s.auth.isLoggedIn);

    //useEffect(() => {
    //    if (!isLoggedIn) return;

    //    const onFocus = async () => {
    //        try {
    //            await dispatch(
    //                apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
    //            ).unwrap();
    //        } catch {
    //            dispatch(logoutUser());
    //        }
    //    };
    //    window.addEventListener('focus', onFocus);
    //    return () => {
    //        window.removeEventListener('focus', onFocus);
    //    };
    //}, [dispatch, isLoggedIn]);

    return (
        <Switch>
            <PublicRoute exact path={URI_INTERNAL.LOGIN_PATH}>
                <Login />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.LOGIN_SSO_PATH}>
                <LoginSSO />{' '}
                {/* your <LoginSSO> that calls userManager.signinRedirect() */}
            </PublicRoute>
            <PublicRoute exact path="/callback">
                <Callback />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.FORGOT_PASSWORD_PATH}>
                <ForgetPassword />
            </PublicRoute>
            <PublicRoute exact path={URI_INTERNAL.RECOVER_PASSWORD_PATH}>
                <RecoverPassword />
            </PublicRoute>
            <PublicRoute exact path="/privacy-policy">
                <PrivacyPolicy />
            </PublicRoute>
            {/* <PublicRoute exact path="/callback">
                <h1>Callback</h1>
            </PublicRoute> */}
            <PrivateRoute path="/">
                <Main />
            </PrivateRoute>
        </Switch>
    );
};

export default App;
